import { getGenerativeModel, type GenerativeModel } from 'firebase/ai';
import { ai } from './client';

export interface ReceiptAiGateway {
  parseReceiptImage: (dataUrl: string) => Promise<string>;
}

function getModel(): GenerativeModel {
  return getGenerativeModel(ai, { model: 'gemini-3.1-flash-lite' });
}

export const receiptAiGateway: ReceiptAiGateway = {
  async parseReceiptImage(dataUrl) {
    const [prefix, base64] = dataUrl.split(',');
    const mediaType = prefix?.split(';')[0]?.split(':')[1] || 'image/jpeg';

    const result = await getModel().generateContent([
      {
        inlineData: {
          data: base64,
          mimeType: mediaType,
        },
      },
      {
        text: `Analyze this receipt image. Extract the following data and respond ONLY with a JSON object (no markdown, no backticks, no explanation):

{
  "store_name": "name of the store",
  "transaction_date": "YYYY-MM-DDTHH:mm",
  "items": [
    { "name": "item name", "quantity": 1, "unit_price": 0.00, "total": 0.00, "category": "beans" }
  ],
  "subtotal": 0.00,
  "discount": 0.00,
  "tax": 0.00,
  "total": 0.00
}

For the "discount" field: if the receipt shows any coupon savings, promotional discount, loyalty savings, or sale reduction applied to the order total, enter that amount as a positive number (e.g. a $5 coupon becomes 5.00). If there is no discount, use 0.

Valid item categories: beans, milk, syrups, beverages, cups, ice, towels, equipment, cleaning, food, other.

Always return valid JSON.`,
      },
    ]);

    if (Array.isArray(result)) {
      const choice = result.find((entry) => {
        if (!entry || typeof entry !== 'object') return false;
        return (entry as Record<string, unknown>)['event.name'] === 'gen_ai.choice';
      }) as { message?: { content?: Array<{ text?: string }> } } | undefined;

      return choice?.message?.content?.[0]?.text || '';
    }

    return result.response.text();
  },
};
